import { Component, Input, OnInit } from '@angular/core';
import { IonNav } from '@ionic/angular';
import { PlatformEnum } from '@panamax/app-state';
import { ListGroupState, ListItemState, ListState } from '@usf/ngrx-list';
import {
  ProductRow,
  ItemTypes,
} from '../../shared/list-detail-management/model/list-detail-management-view.model';
import { SelectedGroup } from '@app/lists/shared/list-detail-management/model/selected-group.model';
import { ListDetailManagementService } from '@app/lists/shared/list-detail-management/services/list-detail-management.service';
@Component({
  selector: 'app-copy-to-groups-modal',
  templateUrl: './copy-to-groups-modal.component.html',
  styleUrls: ['./copy-to-groups-modal.component.scss'],
})
export class CopyToGroupsModalComponent implements OnInit {
  @Input() selectedProducts: ProductRow[];
  @Input() title: string;
  @Input() list: ListState;
  @Input() groups: ListGroupState[];
  @Input() selectedGroup: ListGroupState;
  @Input() listItems: ListItemState[];
  @Input() platform: PlatformEnum;
  @Input() dismissFunc: Function;

  platformRef = PlatformEnum;
  selection = false;
  selectedGroups: SelectedGroup[] = [];
  numGroupsSelected = 0;

  constructor(
    readonly listDetailManagementService: ListDetailManagementService,
  ) {}

  ngOnInit() {
    let counter = 0;

    this.groups.forEach(group => {
      if (group.groupName !== this.selectedGroup.groupName) {
        this.selectedGroups.push({
          groupState: group,
          items: group.listItemKeys
            ? this.listItems.slice(
                counter,
                counter + group.listItemKeys?.length,
              )
            : [],
          isSelected: false,
        });
        if (group.listItemKeys) {
          counter += group.listItemKeys.length;
        }
      }
    });
  }

  submit() {
    const groupStateArray = this.generateSelectedItemsArray();
    this.listDetailManagementService.copyProducts(
      this.list,
      this.selectedGroup.listGroupKey,
      this.selectedGroups,
      groupStateArray,
    );
    this.dismissModal();
  }

  onSelectGroup(groupName: string, isSelected: boolean) {
    this.selectedGroups.forEach(entry => {
      if (entry?.groupState?.groupName === groupName) {
        entry.isSelected = !isSelected;
        if (entry.isSelected) {
          this.numGroupsSelected++;
        } else {
          if (this.numGroupsSelected !== 0) {
            this.numGroupsSelected--;
          }
        }
      }
    });
  }

  generateSelectedItemsArray() {
    const selectedItems = this.selectedProducts.map(
      (productRow: ProductRow) => {
        if (productRow.itemType === ItemTypes.product) {
          if (productRow?.isChecked && productRow?.isChecked !== undefined) {
            return {
              product: productRow?.summary,
              item: productRow?.item,
            };
          }
        }
      },
    );
    return selectedItems;
  }

  dismissModal = () => {
    this.dismissFunc();
  };
}
